import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { CaseEnvChangeRedirectService } from '@modules/common/services/case-env-change-redirect.service';
import { CurrentEnvironmentService } from '@modules/common/services/current-environment.service';
import { CurrentRouteService } from "@modules/common/services/current-route.service";
import { ReplaceRouteParameterService } from '@modules/common/services/replace-route-parameter.service';
import { BehaviorSubject, Observable } from "rxjs";
import { filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class CurrentCaseService {
    constructor(
        private _router: Router,
        private _currentRouteService: CurrentRouteService,
        private _replaceRouteParameterService: ReplaceRouteParameterService,
        private _currentEnvironmentService: CurrentEnvironmentService,
        private _caseEnvChangeRedirectService: CaseEnvChangeRedirectService
    ) {
        this._router
            .events
            .pipe(filter(e => e instanceof NavigationEnd))
            .subscribe(() => this.onNavigation());
    }

    private _caseChangedSubject = new BehaviorSubject<string>('');

    public getCurrentCaseName(): string {
        return this._currentRouteService.getCurrentRoute().params['clientName'] || '';
    }

    public setCurrentCase(newCaseName: string): void {
        this._router.navigate(this.getUpdatedUrl(newCaseName));
    }

    public get caseChanged(): Observable<string> {
        return this._caseChangedSubject;
    }

    private onNavigation(): void {
        const newCaseName = this.getCurrentCaseName();
        if (newCaseName != this._caseChangedSubject.getValue()) {
            this._caseChangedSubject.next(newCaseName);
        }
    }

    private getUpdatedUrl(newCaseName: string): string[] {
        const currentRoute = this._currentRouteService.getCurrentRoute();
        const currentEnvironmentName = this._currentEnvironmentService.getCurrentEnvironmentName();

        if (currentRoute.data && currentRoute.data.caseEnvChangeRedirect) {
            return this._caseEnvChangeRedirectService.getCaseEnvChangeRedirectUrl(currentRoute.data.caseEnvChangeRedirect, newCaseName, currentEnvironmentName);
        }

        const result = this._replaceRouteParameterService.replaceRouteParameter({
            route: currentRoute,
            paramName: 'clientName',
            paramValue: newCaseName,
            leaveOutEmptyParameter: true
        });

        if (!this.getCurrentCaseName() && newCaseName) {
            result.splice(currentEnvironmentName ? 1 : 0, 0, newCaseName);
        }

        return result;
    }
}
